module.exports = __webpack_public_path__ + "static/OG_How-we-di-it-3e5c343c623a9d5485a48206a2931236.png";